/* Tightknit — dynamic currency display.
   Pairs with Shopify Markets. Reads window.Shopify.currency (set by Shopify when
   Markets is enabled with non-shop currencies live) and re-renders any visible
   USD-coded price in the shopper's active currency with no decimals. */
(function () {
  var s = window.Shopify || {};
  var c = s.currency || {};
  var SEED = window.__WILLA_CURRENCY__ || {};

  var ACTIVE  = c.active || SEED.active || 'USD';
  var SHOPCUR = SEED.shop || 'USD';

  /* A REAL rate, or no conversion at all.

     Rate resolution order:
       1. window.Shopify.currency.rate — usable only if it is a genuine conversion.
          Under Markets it is "1.0", because Shopify's OWN prices arrive already
          converted. Our hardcoded USD literals are not, so 1.0 is useless here.
       2. __WILLA_CURRENCY__.rate — presentment ÷ USD base, computed in theme.liquid
          from a real Shopify-converted price. This is the one that does the work.

     A rate of ~1 in a foreign market means "no usable rate", not "parity". */
  function usable(r) { return isFinite(r) && r > 0 && Math.abs(r - 1) > 0.0001; }
  var RATE = parseFloat(c.rate);
  if (!usable(RATE)) RATE = parseFloat(SEED.rate);

  /* HARD SAFETY RAIL: never rewrite prices while displaying in the shop's own
     currency. The US site must be untouchable regardless of what rate arrives —
     a bad USD_BASE_CENTS in theme.liquid would otherwise rewrite $54 as $5,400.
     Foreign currencies get a generous band on purpose: JPY/KRW/VND rates are
     legitimately in the hundreds or thousands. */
  var FOREIGN    = ACTIVE !== SHOPCUR;
  var RATE_KNOWN = FOREIGN && usable(RATE);
  if (!RATE_KNOWN) RATE = 1;

  var LOCALE = (navigator.language || 'en-US');

  function fmt(usdDollars) {
    var n = Math.round(usdDollars * RATE);
    try {
      return new Intl.NumberFormat(LOCALE, {
        style: 'currency',
        currency: ACTIVE,
        maximumFractionDigits: 0,
        minimumFractionDigits: 0
      }).format(n);
    } catch (e) {
      return '$' + n;
    }
  }

  /* No-op when already in shop currency at parity, AND whenever we have no real
     rate to convert with — leaving "$49" alone is honest; "A$49" is not. */
  var IDENTITY = !RATE_KNOWN || (ACTIVE === 'USD' && Math.abs(RATE - 1) < 0.0001);

  function scan(root) {
    root = root || document.body;
    if (!root) return;

    /* Nothing below can run without a real rate. This used to convert "even at
       parity", which is precisely how USD literals got restamped as A$/C$/£/€. */
    if (IDENTITY) return;

    /* 1. Explicit spans — author-coded cents in USD. */
    var explicit = root.querySelectorAll('[data-money-usd]:not([data-money-done])');
    for (var i = 0; i < explicit.length; i++) {
      var el = explicit[i];
      var cents = parseInt(el.getAttribute('data-money-usd'), 10);
      if (isNaN(cents)) continue;
      el.textContent = fmt(cents / 100);
      el.setAttribute('data-money-done', '1');
    }

    /* 2. Auto-scan — replace $N(,NNN)?(.NN)? patterns inside text nodes within
          [data-money-scan] regions. Skips subtrees marked [data-money-skip]. */
    var areas = root.querySelectorAll('[data-money-scan]:not([data-money-scanned])');
    if (!areas.length) return;

    var priceRe = /\$(\d{1,3}(?:,\d{3})*(?:\.\d+)?)/g;

    for (var j = 0; j < areas.length; j++) {
      var area = areas[j];
      area.setAttribute('data-money-scanned', '1');

      var walker = document.createTreeWalker(area, NodeFilter.SHOW_TEXT, {
        acceptNode: function (n) {
          if (!n.nodeValue || !/\$\d/.test(n.nodeValue)) return NodeFilter.FILTER_REJECT;
          var p = n.parentNode;
          while (p && p !== area) {
            if (p.nodeType === 1) {
              var tag = p.tagName;
              if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'TEXTAREA') return NodeFilter.FILTER_REJECT;
              if (p.hasAttribute('data-money-skip')) return NodeFilter.FILTER_REJECT;
              if (p.hasAttribute('data-money-usd')) return NodeFilter.FILTER_REJECT;
            }
            p = p.parentNode;
          }
          return NodeFilter.FILTER_ACCEPT;
        }
      });

      var nodes = [], n;
      while ((n = walker.nextNode())) nodes.push(n);

      for (var k = 0; k < nodes.length; k++) {
        var node = nodes[k];
        node.nodeValue = node.nodeValue.replace(priceRe, function (_, num) {
          return fmt(parseFloat(num.replace(/,/g, '')));
        });
      }
    }
  }

  window.WillaMoney = {
    fmt: fmt,
    scan: scan,
    active: ACTIVE,
    rate: RATE,
    /* Force re-scan of a region after dynamic content insertion. */
    refresh: function (root) {
      if (root && root.removeAttribute) root.removeAttribute('data-money-scanned');
      scan(root);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }
})();
